import { Dispatch } from "@reduxjs/toolkit";
import { FooterThingyActions } from "../actions/actions";


export const requestDataFromApp =() => {
    return (
        dispatch:Dispatch<any>, 
    )=>{       
        // Absolute, not "./version.txt": below /license/... the relative
        // address pointed at /license/version.txt, which the SPA fallback
        // answers with index.html - the footer then showed HTML.
        // no-store: a cached copy kept showing an old version after an update.
        fetch('/version.txt', { cache: 'no-store' })
        .then((r) => r.text())
        .then(text  => {
            dispatch(FooterThingyActions.resetData({version:versionFromText(text)}))
        })
        .catch(() => dispatch(FooterThingyActions.resetData({version:"?"})));
    }

    
}

/**
 * The version from the content of version.txt: its first line, trimmed
 * ("7.320", or "dev" in a development build). Anything that looks like
 * markup - an HTML page served instead of the file - or is empty or overlong
 * becomes "?". Pure.
 */
export function versionFromText(text: string | null | undefined): string {
    const line = (text ?? "").split(/\r?\n/)[0].trim();
    return line === "" || line.length > 40 || /[<>]/.test(line) ? "?" : line;
}
